const COLUMN_LINKS = [
  {
    title: "栏目速览",
    links: [
      { label: "今日瓜田", href: "#guatian" },
      { label: "聊点什么", href: "#lanmu" },
      { label: "为什么加入", href: "#why" },
    ],
  },
  {
    title: "加入我们",
    links: [
      { label: "入群指南", href: "#join" },
      { label: "群友口碑", href: "#kouping" },
      { label: "入群申请", href: "#joinform" },
    ],
  },
  {
    title: "常见问题",
    links: [
      { label: "九色吃瓜是什么", href: "#faq" },
      { label: "入群收费吗", href: "#faq" },
      { label: "怎么分辨真假", href: "#faq" },
    ],
  },
];

export default function Footer() {
  return (
    <footer className="bg-secondary-900 text-secondary-100">
      <div className="mx-auto w-full max-w-7xl px-4 py-12 md:px-6 md:py-16">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-[1.4fr_1fr_1fr_1fr]">
          <div>
            <div className="flex items-center gap-2">
              <span className="flex h-9 w-9 items-center justify-center rounded-full bg-secondary-500 text-background-50">
                <i className="ri-message-3-line text-lg" aria-hidden="true"></i>
              </span>
              <span className="font-heading text-lg font-bold text-background-50">九色吃瓜</span>
            </div>
            <p className="mt-4 max-w-xs text-sm leading-relaxed text-secondary-100/80">
              面向年轻用户的娱乐话题同好聚集地，聚合新鲜瓜、剧综热梗与话题复盘，陪你把瓜吃明白、蹲到底。
            </p>
            <div className="mt-5 flex flex-wrap gap-2">
              {["理性吃瓜", "不信谣", "友好交流"].map((t) => (
                <span
                  key={t}
                  className="rounded-full bg-secondary-800 px-3 py-1 text-xs text-secondary-200"
                >
                  {t}
                </span>
              ))}
            </div>
          </div>

          {COLUMN_LINKS.map((col) => (
            <nav key={col.title} aria-label={col.title}>
              <h4 className="font-heading text-sm font-bold text-background-50">{col.title}</h4>
              <ul className="mt-4 space-y-3">
                {col.links.map((link) => (
                  <li key={link.label}>
                    <a
                      href={link.href}
                      className="inline-flex items-center gap-1 whitespace-nowrap text-sm text-secondary-100/80 transition-colors hover:text-background-50"
                    >
                      {link.label}
                      <i className="ri-arrow-right-s-line text-base" aria-hidden="true"></i>
                    </a>
                  </li>
                ))}
              </ul>
            </nav>
          ))}
        </div>

        <div className="mt-12 flex flex-col items-start justify-between gap-4 border-t border-secondary-800 pt-6 sm:flex-row sm:items-center">
          <div className="flex flex-col gap-2">
            <p className="text-xs text-secondary-100/70">
              如需联系，可发送邮件至{" "}
              <a href="mailto:hello@jiuse-chigua.com" className="underline decoration-secondary-500 underline-offset-2 hover:text-background-50">
                hello@jiuse-chigua.com
              </a>
            </p>
            <p className="text-xs text-secondary-100/60">
              本平台为话题讨论内容整理，倡导理性吃瓜，不传播未经证实的信息。
            </p>
          </div>
          <p className="text-xs text-secondary-100/60">© {new Date().getFullYear()} 九色吃瓜 · 保留所有权利</p>
        </div>
      </div>
    </footer>
  );
}